import React from 'react';
import PropTypes from 'prop-types';
import StyledShapedImage from './shapedImage.style';

const ShapedImage = ({
  src,
  srcset,
  sizes,
  alt,
  shadow = 'center',
  shadowY = 'bottom',
  shadowSize = 'md',
  clipForm,
  onlyBackground = false,
  colorScheme,
  imageClassName,
  hoverEffect = true
}) => (
  <StyledShapedImage
    hoverEffect={hoverEffect}
    colorScheme={colorScheme}
    shadow={shadow}
    shadowY={shadowY}
    shadowSize={shadowSize}
    onlyBackground={onlyBackground}
    clipForm={clipForm}
  >
    <div className="shaped-image__container">
      <div className="shaped-image__background-shape" aria-hidden="true" />
      <div className="shaped-image__form">
        <img
          loading="lazy"
          src={src}
          srcSet={srcset}
          sizes={sizes}
          alt={alt || 'Futurium Berlin'}
          className={`shaped-image__item ${imageClassName}`}
        />
      </div>
    </div>
  </StyledShapedImage>
);

ShapedImage.propTypes = {
  src: PropTypes.string,
  srcset: PropTypes.string,
  sizes: PropTypes.string,
  alt: PropTypes.string,
  shadow: PropTypes.string,
  shadowY: PropTypes.string,
  clipForm: PropTypes.string,
  colorScheme: PropTypes.string,
  imageClassName: PropTypes.string,
  shadowSize: 'md',
  onlyBackground: PropTypes.bool,
  hoverEffect: PropTypes.bool
};

export default ShapedImage;
